<div class="user-settings-grid" *ngIf="user$ | async as user">
  <div class="theme-picker">
    <span>Theme</span>
    <mat-form-field appearance="fill" class="theme-select">
      <mat-select [value]="selectedTheme" (selectionChange)="onThemeChange($event.value)">
        <mat-option *ngFor="let t of themes" [value]="t.value">
          <span class="theme-option">
            <span class="theme-swatch" [style.background]="t.colors.bg" [style.border-color]="t.colors.accent">
              <span class="theme-swatch-dot" [style.background]="t.colors.accent"></span>
            </span>
            {{ t.label }}
          </span>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="font-picker">
    <span>Font</span>
    <mat-form-field appearance="fill" class="font-select">
      <mat-select [value]="selectedFont" (selectionChange)="onFontChange($event.value)">
        <mat-option *ngFor="let f of fontOptions" [value]="f.value">
          <span [style.font-family]="f.value + ', sans-serif'">{{ f.label }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <mat-form-field class="example-full-width" appearance="fill">
    <mat-label>Name</mat-label>
    <input matInput (input)="onChange()" [disabled]="false" [value]="user.name" [(ngModel)]="name">
  </mat-form-field>
  <mat-form-field class="example-full-width" appearance="fill">
    <mat-label>Email</mat-label>
    <input matInput (input)="onChange()" [disabled]="false" [value]="user.email" [(ngModel)]="email">
  </mat-form-field>
  <mat-form-field class="example-full-width" appearance="fill">
    <mat-label>Avatar</mat-label>
    <input matInput (input)="onChange()" [disabled]="false" [value]="user.avatar" [(ngModel)]="avatar">
  </mat-form-field>
  <mat-form-field class="example-full-width" appearance="fill">
    <mat-label>New Password</mat-label>
    <input type="password" (input)="onChange()" matInput [disabled]="false" [(ngModel)]="password">
  </mat-form-field>

  <button mat-raised-button [disabled]="!allowSave" color="accent" (click)="save()">Save</button>
</div>
